/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Membership_Page_SubtitleInputs */

const fr_membership_page_subtitle = /** @type {(inputs: Membership_Page_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le détail de votre abonnement à la salle : palier, accès et prochaine échéance.`)
};

/**

* @param {Membership_Page_SubtitleInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const membership_page_subtitle = /** @type {((inputs?: Membership_Page_SubtitleInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Membership_Page_SubtitleInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_membership_page_subtitle(inputs)
});